import { FC } from "react";
import { Box, Typography } from "@mui/material";

import { RiLinkM } from "react-icons/ri";

import { MatchedManualPayment } from "../../../../../types/claims";
import { formatInstant } from "../../../../helpers/dataHelper";
import ClaimDocumentCard from "../record-payment/ClaimDocumentCard";

/**
 * Shown on an 835 a manual payment was joined to (REV-2585): the 835 is the
 * payment of record, who recorded the manual payment and who joined it, and the
 * manual payment's correspondence when it had one.
 */
const MatchedManualPaymentNote: FC<{
  matched: MatchedManualPayment;
  claimId: string;
}> = ({ matched, claimId }) => (
  <Box
    data-testid="matched-manual-payment"
    sx={{
      m: 2,
      p: 1.5,
      borderRadius: "8px",
      border: "1px solid",
      borderColor: "divider",
      backgroundColor: "grey.50",
      display: "flex",
      flexDirection: "column",
      gap: 0.75,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box sx={{ display: "inline-flex", color: "text.secondary" }}>
        <RiLinkM size={16} />
      </Box>
      <Typography sx={{ fontSize: "0.8125rem", fontWeight: 600 }}>
        Matched manual payment
      </Typography>
    </Box>

    <Typography sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
      This 835 replaces a payment recorded by hand on{" "}
      {formatInstant(matched.createdAt)}
      {matched.createdBy ? ` by ${matched.createdBy}` : ""}, so the payment
      counts once.{" "}
      {matched.joinedBy
        ? `Joined by ${matched.joinedBy}.`
        : "Joined automatically when the 835 arrived."}
    </Typography>

    {matched.document && (
      <Box sx={{ pt: 0.5 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          component="div"
          sx={{ fontSize: "0.65rem", textTransform: "uppercase", mb: 1 }}
        >
          Correspondence
        </Typography>
        <ClaimDocumentCard document={matched.document} claimId={claimId} />
      </Box>
    )}
  </Box>
);

export default MatchedManualPaymentNote;
